import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/apiClient";
import type { Supplier } from "../api/types";

export function SuppliersPage() {
  const [rows, setRows] = useState<Supplier[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      setRows(await api.listSuppliers(true));
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "Failed to load suppliers");
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <div>
          <h2 className="page-title">Suppliers</h2>
          <p className="page-subtitle">Purchase partners for flower batches.</p>
        </div>
        <Link to="/app/suppliers/new" className="button">
          New supplier
        </Link>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      <div className="card table-scroll">
        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.id}>
                <td>{s.code}</td>
                <td>{s.name}</td>
                <td>{s.isActive ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
